import { emailRegex } from "./Regex";

export default function EmailValidator(email: string): boolean {
  return emailRegex.test(email);
}
